module.exports = {"652828100":"特吾里克镇","652828101":"塔哈其镇","652828102":"曲惠镇","652828200":"乌什塔拉回族民族乡","652828203":"苏哈特乡","652828204":"乃仁克尔乡","652828205":"新塔热乡","652828400":"清水河农场","652828402":"和硕县马兰公安管区","652828504":"兵团二师二十四团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652828.json
// module id = 3089
// module chunks = 0